import { action, observable } from 'mobx';
import { ModalStore } from 'ui/base/modal';
import { AvatarCode as AvatarCodeType } from 'services/accounts/types';

export class AvatarStore {
  modal: ModalStore;

  @observable.ref
  value: AvatarCodeType;

  @observable.ref
  highlighted: AvatarCodeType;

  constructor(avatar: AvatarCodeType) {
    this.modal = new ModalStore(false);
    this.value = avatar;
    this.highlighted = avatar;
  }

  reloadHighlighted = action((): void => {
    this.highlighted = this.value;
  });

  commitHighlighted = action((): void => {
    this.value = this.highlighted;
  });

  setHighlighted = action((highlighted: AvatarCodeType) => {
    this.highlighted = highlighted;
  });
}